// extracted by mini-css-extract-plugin
export default {"CourseHeader":"CourseHeader_CourseHeader__MLI61","Container":"CourseHeader_Container__m3sVQ"};